import * as Dialog from '@radix-ui/react-dialog';
import { forwardRef } from 'react';

import { classNames } from '../../../server/utils/classNames';

export type ModalTitleProps = React.HTMLAttributes<HTMLDivElement>;

export const ModalTitle = forwardRef<HTMLDivElement, ModalTitleProps>(({ className, ...props }, ref) => {
	return <Dialog.Title className={classNames('w-full text-heading-sm', className)} ref={ref} {...props} />;
});
